import { render, staticRenderFns } from "./GameTable.vue?vue&type=template&id=dc6bc86a&scoped=true&"
import script from "./GameTable.vue?vue&type=script&lang=js&"
export * from "./GameTable.vue?vue&type=script&lang=js&"
import style0 from "./GameTable.vue?vue&type=style&index=0&id=dc6bc86a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6bc86a",
  null
  
)

export default component.exports